
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M9.14 10.654a5.453 5.453 0 00-7.59 5.013.55.55 0 11-1.1-.001 6.553 6.553 0 019.12-6.024.55.55 0 01-.43 1.012z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M2.783 4.666a4.217 4.217 0 118.434 0 4.217 4.217 0 01-8.434 0zM7 1.55a3.117 3.117 0 100 6.234A3.117 3.117 0 007 1.55zm2.783 14.115a5.884 5.884 0 1111.767 0 5.884 5.884 0 01-11.767 0zm5.883-4.784a4.784 4.784 0 100 9.567 4.784 4.784 0 000-9.567z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M12.839 15.114h5.657a.55.55 0 010 1.1H12.84a.55.55 0 110-1.1z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M15.667 12.285a.55.55 0 01.55.55v5.657a.55.55 0 01-1.1 0v-5.657a.55.55 0 01.55-.55z"}})])
          )
        }
      }
    